(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pr-basque"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('[data-filters]').hidden=false;root.querySelector('[data-unit-controls]').hidden=false;const cards=[...root.querySelectorAll('[data-fabric][data-length]')];function filter(){const f=root.querySelector('[name="basque-fabric"]:checked').value,l=root.querySelector('[name="basque-length"]:checked').value;let count=0;cards.forEach(c=>{c.hidden=!((f==='all'||c.dataset.fabric===f)&&(l==='all'||c.dataset.length===l));if(!c.hidden)count++});const status=root.querySelector('[data-result-count]');status.textContent=count+' '+status.dataset.label;root.querySelector('[data-no-results]').hidden=count!==0}root.addEventListener('change',e=>{if(e.target.name==='basque-fabric'||e.target.name==='basque-length')filter();if(e.target.name==='basque-unit')root.querySelectorAll('[data-cm]').forEach(td=>{td.textContent=e.target.value==='in'?(Number(td.dataset.cm)/2.54).toFixed(1)+' in':td.dataset.cm+' cm'})});root.querySelectorAll('[data-set-fabric]').forEach(a=>a.addEventListener('click',()=>{root.querySelector('[name="basque-fabric"][value="'+a.dataset.setFabric+'"]').checked=true;root.querySelector('[name="basque-length"][value="all"]').checked=true;filter()}));filter();const sticky=root.querySelector('[data-sticky]');const ob=new IntersectionObserver(es=>{es.forEach(e=>{if(e.target.classList.contains('pr-hero'))root.dataset.hero=String(e.isIntersecting);if(e.target.id==='basque-shop')root.dataset.shop=String(e.isIntersecting)});sticky.hidden=root.dataset.hero!=='false'||root.dataset.shop==='true'},{threshold:0});ob.observe(root.querySelector('.pr-hero'));ob.observe(root.querySelector('#basque-shop'))}document.querySelectorAll('[data-basque]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-basque]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-solution-dressing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pr-solution-dressing')) {
    customElements.define('pr-solution-dressing', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('[data-filters]');
        this.grid = this.querySelector('[data-products]');
        this.cards = [...this.querySelectorAll('[data-product]')];
        this.selects = [...this.querySelectorAll('[data-filter]')];
        this.limit = 8;
        this.sizeOrder = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL'];
        this.values = (card,key) => (card.dataset[key] || '').split('|').map(v => v.trim()).filter(Boolean);
        this.selects.forEach(select => {
          const key = select.dataset.filter;
          const values = [...new Set(this.cards.flatMap(card => this.values(card,key)))];
          values.sort((a,b) => key === 'size' && this.sizeOrder.includes(a) && this.sizeOrder.includes(b) ? this.sizeOrder.indexOf(a)-this.sizeOrder.indexOf(b) : a.localeCompare(b,undefined,{numeric:true}));
          values.forEach(value => select.add(new Option(value,value)));
          select.parentElement.hidden = values.length < 2 && key !== 'size';
        });
        this.form.hidden = false;
        this.form.addEventListener('submit', event => event.preventDefault());
        this.form.addEventListener('change', () => { this.limit=8; this.update(); });
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.selects.forEach(select => { select.value=''; });
          this.querySelector('[data-sort]').value='recommended';
          this.querySelector('[data-available]').checked=true;
          this.limit=8;
          this.update();
        });
        this.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => this.form.reset()));
        this.querySelector('[data-more]').addEventListener('click', () => {
          const previous=this.limit;
          this.limit+=8;
          const matches=this.update();
          matches[previous]?.querySelector('a')?.focus({preventScroll:true});
        });
        this.querySelectorAll('[data-preset-field]').forEach(link => link.addEventListener('click', () => {
          this.selects.forEach(select => { select.value = select.dataset.filter === link.dataset.presetField ? link.dataset.presetValue : ''; });
          this.form.querySelector('[data-available]').checked=true;
          this.limit=8;
          this.update();
          this.querySelector('.pr-sol__explorer h2').focus({preventScroll:true});
        }));
        this.setupBasket();
        this.update();
      }
      setupBasket() {
        this.basket=this.querySelector('[data-basket-dialog]');
        this.basketForm=this.querySelector('[data-basket-form]');
        this.variantSelect=this.querySelector('[data-basket-variant]');
        this.basketStatus=this.querySelector('[data-basket-status]');
        this.basketError=this.querySelector('[data-basket-error]');
        this.basketSubmit=this.querySelector('[data-basket-submit]');
        this.basketLink=this.querySelector('[data-basket-link]');
        this.savedVariants=new Map();
        this.chooseTitle=this.basket.querySelector('h2').textContent;
        this.querySelectorAll('[data-quick-add]').forEach(button => {
          button.hidden=false;
          button.addEventListener('click',()=>this.openBasket(button));
        });
        this.querySelectorAll('[data-basket-close]').forEach(button => button.addEventListener('click',()=>{
          if (!this.basketBusy) this.basket.close();
        }));
        this.basket.addEventListener('cancel',event=>{ if(this.basketBusy) event.preventDefault(); });
        this.basket.addEventListener('close',()=>this.basketTrigger?.focus({preventScroll:true}));
        this.basketForm.addEventListener('submit',event=>{
          event.preventDefault();
          if (this.basketForm.reportValidity()) this.addToBasket();
        });
      }
      openBasket(button) {
        if(this.basketBusy) return;
        this.basketTrigger=button;
        this.quickProduct=button.closest('[data-quick-product]');
        this.variantSelect.replaceChildren(this.quickProduct.querySelector('template').content.cloneNode(true));
        this.querySelector('[data-basket-product]').textContent=this.quickProduct.dataset.title;
        this.basketStatus.textContent='';
        this.basketError.textContent='';
        this.basketLink.hidden=true;
        this.basketForm.hidden=false;
        this.basket.querySelector('h2').textContent=this.chooseTitle;
        const size=this.querySelector('[data-filter="size"]').value;
        const options=[...this.variantSelect.options].filter(option=>option.value && !option.disabled);
        const matching=size ? options.filter(option=>option.dataset.size===size) : [];
        const remembered=!size && options.find(option=>option.value===this.savedVariants.get(this.quickProduct.dataset.quickProduct));
        const selected=size ? (matching.length===1 ? matching[0] : null) : remembered || (this.quickProduct.dataset.default==='true' ? options[0] : null);
        this.variantSelect.value=selected?.value || '';
        this.basket.showModal();
        if(selected) this.addToBasket();
        else this.variantSelect.focus();
      }
      async addToBasket() {
        if(this.basketBusy || !this.variantSelect.value) return;
        const option=this.variantSelect.selectedOptions[0];
        if(option.disabled) return;
        const variantId=option.value;
        this.basketBusy=true;
        this.basketSubmit.disabled=true;
        this.variantSelect.disabled=true;
        this.querySelectorAll('[data-basket-close]').forEach(button=>{button.disabled=true;});
        this.basketError.textContent='';
        this.basketStatus.textContent=this.basket.dataset.adding;
        let added=false;
        try {
          const root=this.basket.dataset.root.replace(/\/?$/,'/');
          const response=await fetch(root+'cart/add.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
          });
          const result=await response.json();
          if(!response.ok) throw new Error(result.description || result.message || this.basket.dataset.error);
          added=true;
          this.savedVariants.set(this.quickProduct.dataset.quickProduct,variantId);
          this.basketForm.hidden=true;
          this.basket.querySelector('h2').textContent=this.basket.dataset.added;
          this.basketStatus.textContent=option.textContent;
          this.basketLink.hidden=false;
          this.basketLink.focus();
          try {
            const cartResponse=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});
            if(cartResponse.ok) {
              const cart=await cartResponse.json();
              document.querySelectorAll('.js-cart-count').forEach(count=>{count.textContent=String(cart.item_count);});
              const config=document.getElementById('cart-config');
              if(config && window.Shopify?.theme?.ajaxCart?.updateView) window.Shopify.theme.ajaxCart.updateView(JSON.parse(config.textContent),cart);
            }
          } catch(refreshError) {}
        } catch(error) {
          if(!added) {
            this.basketStatus.textContent='';
            this.basketError.textContent=error.message==='Failed to fetch' ? this.basket.dataset.error : error.message;
            this.basketLink.hidden=false;
          }
        } finally {
          this.basketBusy=false;
          this.basketSubmit.disabled=false;
          this.variantSelect.disabled=false;
          this.querySelectorAll('[data-basket-close]').forEach(button=>{button.disabled=false;});
        }
      }
      update() {
        const availableOnly=this.querySelector('[data-available]').checked;
        const matches=this.cards.filter(card => (!availableOnly || card.dataset.available==='true') && this.selects.every(select => !select.value || this.values(card,select.dataset.filter).includes(select.value)));
        const sort=this.querySelector('[data-sort]').value;
        if (sort==='price-asc') matches.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
        if (sort==='price-desc') matches.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
        this.cards.forEach(card => { card.hidden=true; });
        matches.forEach((card,index) => { this.grid.append(card); card.hidden=index>=this.limit; });
        const visible=Math.min(matches.length,this.limit);
        this.querySelector('[data-status]').textContent=this.dataset.countLabel.replace('[shown]',String(visible)).replace('[total]',String(matches.length));
        this.querySelector('[data-empty]').hidden=matches.length>0;
        this.querySelector('[data-more]').hidden=matches.length<=this.limit;
        return matches;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-waterfall"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('[data-units]').hidden=false;root.addEventListener('change',e=>{if(!e.target.matches('[data-variant]'))return;const s=e.target,c=s.closest('[data-product]'),o=s.selectedOptions[0];c.querySelector('[data-product-link]').href=s.dataset.base+(s.value?'?variant='+encodeURIComponent(s.value):'');if(o.dataset.price)c.querySelector('[data-price]').textContent=o.dataset.price});root.querySelectorAll('[data-unit]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-unit]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('[data-cm]').forEach(td=>td.textContent=b.dataset.unit==='in'?(Number(td.dataset.cm)/2.54).toFixed(1)+' in':td.dataset.cm+' cm')}));if('IntersectionObserver' in window){const sticky=root.querySelector('[data-sticky]');const observer=new IntersectionObserver(es=>{es.forEach(e=>{if(e.target.classList.contains('wf-hero'))root.dataset.hero=String(e.isIntersecting);if(e.target.id==='waterfall-shop')root.dataset.shop=String(e.isIntersecting);if(e.target.classList.contains('wf-final'))root.dataset.final=String(e.isIntersecting)});sticky.hidden=root.dataset.hero!=='false'||root.dataset.shop==='true'||root.dataset.final==='true'},{threshold:0});['.wf-hero','#waterfall-shop','.wf-final'].forEach(s=>observer.observe(root.querySelector(s)))}}document.querySelectorAll('[data-waterfall]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-waterfall]').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
